var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49999 6.16493L4.5 6.17188",
    stroke: "#092C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.83349C1.5 1.72892 2.39543 0.833496 3.5 0.833496H8.7759C9.24377 0.833496 9.69684 0.997529 10.0563 1.29705L11.5 2.50016L12.7804 3.56714C13.2364 3.94712 13.5 4.51002 13.5 5.10358V12.1668C13.5 13.2714 12.6046 14.1668 11.5 14.1668H3.5C2.39543 14.1668 1.5 13.2714 1.5 12.1668V2.83349Z",
    stroke: "#092C4C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5H4.5",
    stroke: "#092C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.8335H4.5",
    stroke: "#092C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessStories);
export default __webpack_public_path__ + "static/media/success-stories.c041bb741983bc4069e84bfa71162322.svg";
export { ForwardRef as ReactComponent };